"use client";

import {
  isRouteErrorResponse,
  useNavigate,
  useRouteError,
} from "react-router-dom";
import { useEffect } from "react";

export default function ErrorPage() {
  const error = useRouteError();
  const navigate = useNavigate();

  useEffect(() => {
    if (isRouteErrorResponse(error) && error.status === 404) {
      console.log(`${error.status}`);
      navigate("/", { replace: true });
    }
  }, [error, navigate]);

  if (isRouteErrorResponse(error)) {
    return (
      <div>
        <h1 className={"text-4xl font-bold"}>{error.status}</h1>
        <p>{<i>{error.statusText}</i>}</p>
        <p>{<i>{error.data}</i>}</p>
      </div>
    );
  } else {
    return (
      <div id={"error-page"}>
        <h1>Oops!</h1>
      </div>
    );
  }
}
